import styled from 'styled-components';
import { space } from 'styled-system';
import pointBreaks from '@styles/styleConstants';

export const ContractWrapper = styled.div(({ isEditing, mobileScrollLimiter }) => `
    width: 100%;
    max-width: 1800px;
    margin: 0 auto;
    padding: 0em 2em;
    background: var(--background);
    -webkit-overflow-scrolling: touch;
    ${(isEditing || mobileScrollLimiter) && 'overflow: hidden; height: 100%'};

    @media screen and (max-width: ${pointBreaks.sm}) {
        padding: 0em 1em;
    }
    
    ${space};
`);

export const HeaderWrapper = styled.div`
    padding: 1em 0em;
    border-bottom: 1px solid var(--border);
    position: sticky;
    top: 0;
    background: var(--background);
    z-index: 200;
    ${space};
`;

export const MobileHeaderContent = styled.div`
    display: none;

    @media screen and (max-width: ${pointBreaks.sm}) {
        display:flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        min-height: 44px;
    }
`;

export const MobileTitleWrapper = styled.div`
    flex: 1;
    margin-left: 1em;
`;

export const HeaderContent = styled.div`
    display:flex;
    justify-content: space-between;
    min-height: 44px;

    @media screen and (max-width: ${pointBreaks.sm}) {
        display:none;
    }
`;

export const HeaderDetails = styled.div`
    display:flex;
    align-items: center;
    flex-wrap: wrap;
    ${space};
`;

export const HeaderActions = styled.div`
    display:flex;
    justify-content: flex-end;
    align-items: center;
    ${space};
`;

export const PageWrapper = styled.div`
    display:flex;
    ${space};
`;

export const PageContent = styled.div`
    width:100%;
    ${space};
`;

export const RejectionWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 0 auto;
    background: var(--card);
    border-radius: 1em;
    padding: 4em 1em 5em 1em;
    margin-bottom: 5em;
    margin-top: 4em;
    max-width: 28em;

    @media screen and (max-width: ${pointBreaks.sm}) {
        margin-top: 2em;
        padding: 2em 1.5em 5em 1.5em;
    }
`;
